module.exports = __webpack_public_path__ + "img/43.maintenance.ab20065e.svg";